<header *ngIf="(authenticationService.organisation$ | async)">
  <img src="{{ (authenticationService.organisation$ | async)?.logo }}" alt="{{ (authenticationService.organisation$ | async)?.display_name }}">
</header>
<fury-page-layout>
  <fury-page-layout-content @fadeInUp>
    <fury-container>
      <fury-page-layout-content-width wide="middle">
        <ng-container *ngIf="!wasteCalendarData">
          <h1>Afvalkalender</h1>
          <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px">
            <p>* Verplicht in te vullen gegevens.</p>
            <mat-form-field>
              <mat-label>Postcode</mat-label>
              <input matInput [formControl]="form.controls.postal_code">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Huisnummer</mat-label>
              <input matInput [formControl]="form.controls.house_number">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Huisletter</mat-label>
              <input matInput [formControl]="form.controls.house_letter">
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="getData()" [disabled]="!form.valid">
              Zoeken
            </button>
          </form>
        </ng-container>
        <ng-container *ngIf="wasteCalendarData">
          <table class="calendar-container">
            <thead>
            <tr>
              <td>
                <h1>Afvalinzameldagen voor {{ form.controls.postal_code.value }} {{ form.controls.house_number.value }}{{ form.controls.house_letter.value }}</h1>
                <div class="buttons">(
                  <a href="#" (click)="clearAddress(); $event.preventDefault()">Adres wijzigen</a>,
                  <a href="#" (click)="print(); $event.preventDefault()">printen</a>
                  )</div>
                <fury-alert-box class="info first-pickup">
                  <ng-container *ngIf="wasteCalendarData.first">{{ wasteCalendarData.first }}</ng-container>
                </fury-alert-box>
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <div class="calendar" *ngFor="let year of Object.keys(wasteCalendarData.collections)">
                  <table *ngFor="let month of Object.keys(wasteCalendarData.collections[year])">
                    <thead>
                    <tr>
                      <th colspan="2">{{ month }} {{ year }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let pickup of wasteCalendarData.collections[year][month]">
                      <tr>
                        <td>{{ pickup.date.day_text }} {{ pickup.date.day }}</td>
                        <td>
                          <ng-container *ngFor="let garbage of pickup['data']">
                            <img src="{{ garbage.icon }}" alt="{{ garbage.display_name }}">
                            <span>{{ garbage.display_name }}</span>
                          </ng-container>
                        </td>
                      </tr>
                    </ng-container>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </ng-container>
        <div class="white-background" *ngIf="isLoading">
          <fury-loading-overlay [isLoading]="true"></fury-loading-overlay>
        </div>
      </fury-page-layout-content-width>
    </fury-container>
  </fury-page-layout-content>
</fury-page-layout>
